/**
 * Loads modules required for the main content matrix
 */

import { loadModule, loadModulesWhenInView } from '@helpers/loadModule';
import cookieConsent from '@modules/cookieConsent';

export default function init(): void {
  cookieConsent();

  // Reveal .js-animate elements on scroll
  loadModule('.js-animate', () => import('@modules/animate'));

  // Load optional modules when in view
  loadModulesWhenInView([
    {
      selector: '.js-social-share-button',
      importer: () => import('@modules/socialShare'),
    },
    {
      selector: '.js-dropdown-trigger',
      importer: () => import('@modules/dropdown'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/gtmFormSubmission'),
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video'),
    },
    {
      selector: '.js-embla',
      importer: () => import('@modules/embla'),
    },
    {
      selector: '.js-map',
      importer: () => import('@modules/mapbox'),
    },
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
  ]);
}
